// src/components/molecules/PropertyForm.tsx

import React from 'react';
import TextEdit from '../atoms/TextEdit';
import SelectFilter from '../organisms/SelectFilter';
import {BusinessProperty} from "../../model/BusinessProperty";


interface PropertyFormProps {
    properties: BusinessProperty[];
    selectedProperty: string;
    onPropertyChange: (value: string) => void;
    onValueChange: (value: string) => void;
    newValue: string;
    title: string;
}

const PropertyForm: React.FC<PropertyFormProps> = ({
                                                       properties,
                                                       selectedProperty,
                                                       onPropertyChange,
                                                       onValueChange,
                                                       newValue,
                                                       title

                                                   }) => {
    const selectedProp = properties.find(p => p.key === selectedProperty);

    return (
        <div>
            <SelectFilter
                id='maintenance-properties'
                label={title}
                value={selectedProperty}
                onChange={onPropertyChange}
                defaultVoidOption={true}
                defaultLabel='Selecione...'
                options={properties.map(p => ({ value: p.key, label: `${p.key} - ${p.value}` }))}
                className='col-span-4'
            />
            <div className="grid grid-cols-2 gap-2 p-2">
                <div className="col-4">
                    <TextEdit
                        label="Variavel"
                        value={selectedProperty}
                        disabled
                    />
                </div>
                <div className="col-4">
                    {selectedProp && selectedProp.isRestrictValue && selectedProp.values ? (
                        <SelectFilter
                            id="restricted-values"
                            label="Selecione o Novo Valor"
                            value={newValue}
                            onChange={onValueChange}
                            defaultLabel="Selecione..."
                            defaultVoidOption={true}
                            options={selectedProp.values.map(v => ({ value: v, label: v }))}
                            className='col-span-4'
                        />
                    ) : (
                        <TextEdit
                            label="Insira Novo Valor"
                            type='text'
                            placeholder=''
                            onChange={(e) => onValueChange(e.target.value)}
                            value={newValue}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default PropertyForm;